export default __webpack_public_path__ + "static/media/File_No_3.0bf3b7d3.pdf";